import React, { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from '@emotion/styled';

import {
  getUser,
  getSubmitting,
  getNoticeText,
  getResetPWError,
} from 'data_system/token_auth/selectors';
import { updatePassword } from 'data_system/token_auth/actions';

import { Theme } from 'ui_system/theme';

import { InlineAnchor } from 'ui_system/token_auth/styles_auth';

import { ChangePasswordModal } from 'ui_system/token_auth/ChangePasswordModal';
import { Notice } from 'views/resource_portal/components/Notice';

const Settings = styled.div`
  max-width: 600px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 20px;
  padding-top: 30px;
  font-size: 16px;
`;

const Header = styled.h1`
  font-size: 24px;
  font-weight: bold;
`;

const Label = styled.div`
  margin-bottom: 4px;
  font-weight: ${(props) => (props.bold ? 'bold' : 'initial')};
`;

const BoldText = styled.div`
  margin-bottom: 24px;
  font-weight: bold;
`;

const Divider = styled.div`
  margin: 32px 0px;
  border-bottom: 1px solid ${Theme.colors.lightLine};
`;

export const AccountSettings = () => {
  const dispatch = useDispatch();
  const { name, email, phone } = useSelector(getUser);

  const passwordError = useSelector(getResetPWError);
  const noticeText = useSelector(getNoticeText);
  const submitting = useSelector(getSubmitting);
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);

  // Close the Change Password Modal when password successfully updates
  useEffect(() => {
    if (!submitting && noticeText) setPasswordModalOpen(false);
  }, [submitting, noticeText]);

  const onSubmitPassword = (params) => {
    dispatch(updatePassword(params));
  };

  return (
    <Fragment>
      <Notice type="success" text={noticeText} show={!!noticeText} />
      <Settings>
        <ChangePasswordModal
          isOpen={passwordModalOpen}
          onClose={() => setPasswordModalOpen(false)}
          onSubmit={onSubmitPassword}
          isSubmitting={submitting}
          submitError={passwordError}
        />
        <Header data-testid="affiliate-portal-title-account-setting">
          Account Settings
        </Header>
        <Divider />
        <BoldText>YOUR INFORMATION</BoldText>
        <Label>Name</Label>
        <BoldText>{name}</BoldText>
        <Label>Email</Label>
        <BoldText>{email}</BoldText>
        <Label>Phone</Label>
        <BoldText>{phone || 'No phone number listed.'}</BoldText>
        <Divider />
        <InlineAnchor
          onClick={() => setPasswordModalOpen(true)}
          underline
          padding="10px 0px"
        >
          Change Password
        </InlineAnchor>
      </Settings>
    </Fragment>
  );
};
